import React, { useContext } from "react";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { CuestionContext } from "../context/CuestionContext";
import RespuestasRadioButton from "./RespuestasRadioButton.jsx";
import RespuestasMultiples from "./RespuestasMultiples";

export function Respuestas() {
  const { cuestion, t } = useContext(CuestionContext);

  const tipoPregunta = () => {
    if (cuestion?.pregunta?.tipoPregunta?.tipo) {
      switch (cuestion.pregunta.tipoPregunta.tipo) {
        case "multipleSelect":
          return <RespuestasMultiples preguntaActual={cuestion.pregunta} />;
        case "radioButton":
        default:
          return <RespuestasRadioButton preguntaActual={cuestion.pregunta} />;
      }
    }
  };

  return (
    <FormControl>
      {cuestion?.pregunta?.respuestas && (
        <>
          <FormLabel id="respuestasPregunta">
            {t("respuestas.labelRespuestas")}
          </FormLabel>
          {tipoPregunta()}
        </>
      )}
    </FormControl>
  );

}
